import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { RoleState } from "./type";

interface LoginPayload {
  // Add appropriate types for the payload
}

export const getModulePermissions = createAsyncThunk(
  "web/get-module-perssion",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/roles-permissions/permissions`);
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        

        const obj = data?.data?.data;
        
        thunkAPI.dispatch(SET_MODULE_PERMISSIONS(obj));
        // SET_CUSTOMERS(obj);
        // return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getAllRoles = createAsyncThunk(
  "web/get-all-roles",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/roles-permissions/roles?page=${payload?.page || 1}`
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        

        const obj = data?.data;
        //   console.log(obj);
        thunkAPI.dispatch(SET_ALL_ROLES(obj));
        // SET_CUSTOMERS(obj);
        // return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getAllRolesDrop = createAsyncThunk(
  "web/get-all-roles-drop",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/roles-permissions/roles-dropdown`);
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        

        const obj = data?.data?.data;
        
        thunkAPI.dispatch(SET_ALL_ROLES_DROP(obj));
        // SET_CUSTOMERS(obj);
        // return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getSingleRole = createAsyncThunk(
  "web/get-single-role",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/roles-permissions/role/${payload?.id || ""}`
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        

        const obj = data?.data;
        //   console.log(obj);
        //   thunkAPI.dispatch(SET_ALL_ROLES(obj));
        // SET_CUSTOMERS(obj);
        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const createRoleFunc = createAsyncThunk(
  "web/createrole-func",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/roles-permissions/role", payload);
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const deleteRoleFunc = createAsyncThunk(
  "web/delete-role-func",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.delete(
        `/admin/roles-permissions/role/${payload?.role_id || ""}`,
        payload
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const editRoleFunc = createAsyncThunk(
  "web/edit-role-func",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.put(
        `/admin/roles-permissions/role/${payload?.role_id || ""}`,
        payload
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

const initialState: RoleState = {
  loading: false,
  loading_modules: false,
  loading_create: false,
  module_permission: [],
  all_roles: {},
  all_roles_drop: [],
  // initialize other state properties
};

const addLabelValue = (list: any) => {
  if (list?.length > 0) {
    const newList = list?.map((chi: any) => {
      return { ...chi, label: chi?.name, value: chi?.id };
    });
    return newList;
  }
};

export const rolesSlice = createSlice({
  name: "roles",
  initialState,

  reducers: {
    SET_MODULE_PERMISSIONS: (state, action) => {
      state.module_permission = action.payload;
    },
    SET_ALL_ROLES: (state, action) => {
      state.all_roles = action.payload;
    },
    SET_ALL_ROLES_DROP: (state, action) => {
      state.all_roles_drop = addLabelValue(action.payload);
    },
  },

  extraReducers: (builder) => {
    // pending state changes
    builder.addCase(getModulePermissions.pending, (state) => {
      state.loading_modules = true;
    });
    builder.addCase(getModulePermissions.fulfilled, (state) => {
      state.loading_modules = false;
    });
    builder.addCase(getModulePermissions.rejected, (state) => {
      state.loading_modules = false;
    });
    builder.addCase(deleteRoleFunc.pending, (state) => {
      state.loading_create = true;
    });
    builder.addCase(deleteRoleFunc.fulfilled, (state) => {
      state.loading_create = false;
    });
    builder.addCase(deleteRoleFunc.rejected, (state) => {
      state.loading_create = false;
    });
    builder.addCase(createRoleFunc.pending, (state) => {
      state.loading_create = true;
    });
    builder.addCase(createRoleFunc.fulfilled, (state) => {
      state.loading_create = false;
    });
    builder.addCase(createRoleFunc.rejected, (state) => {
      state.loading_create = false;
    });
    builder.addCase(editRoleFunc.pending, (state) => {
      state.loading_create = true;
    });
    builder.addCase(editRoleFunc.fulfilled, (state) => {
      state.loading_create = false;
    });
    builder.addCase(editRoleFunc.rejected, (state) => {
      state.loading_create = false;
    });
    builder.addCase(getAllRoles.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllRoles.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllRoles.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getSingleRole.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleRole.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getSingleRole.rejected, (state) => {
      state.loading = false;
    });
  },
});

// Action creators are generated for each case reducer function
export const { SET_MODULE_PERMISSIONS, SET_ALL_ROLES, SET_ALL_ROLES_DROP } =
  rolesSlice.actions;

export default rolesSlice.reducer;
